<template>
    <div class="learnworlds-button-wrapper no-margin-bottom lw-content-block learnworlds-element" v-show="display">
        <button class="learnworlds-button no-margin-top learnworlds-button-small learnworlds-button-solid-accent1 learnworlds-element" @click="loadMoreClicked">
            <span>{{label}}</span>
        </button>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "LoadMore",
        mixins: [ComponentTemplatesMixin],
        props: {
            label: {
                type: String
            },
            display: {
                type: Boolean
            },
            template: {
                type: String
            }
        },
        methods: {
            loadMoreClicked () {
                this.emitAction('action-triggered',this.template);
            }
        }
    }
</script>

